import {AppAction} from '../../appActions';
import {InboxesPanelActionsEnum} from './inboxesPanelActions';
import {InboxesPanelState} from './inboxesPanelState';

export function inboxesPanelReducer(state: InboxesPanelState, action: AppAction): InboxesPanelState {
  switch (action.type) {
    case InboxesPanelActionsEnum.NAVIGATED:
      return {
        ...state,
        parameters: action.payload.parameters,
      };

    case InboxesPanelActionsEnum.SHOW_PIN_TAG_ERRORS_BANNER:
      return {
        ...state,
        pinTagBannerErrors: action.payload.errors,
      };

    case InboxesPanelActionsEnum.DISMISS_PIN_TAG_ERRORS_BANNER:
      return {
        ...state,
        pinTagBannerErrors: [],
      };

    case InboxesPanelActionsEnum.STARTED_EDITING_WORKSPACES:
      return {
        ...state,
        isEditingWorkspaces: true,
      };

    case InboxesPanelActionsEnum.STOPPED_EDITING_WORKSPACES:
      return {
        ...state,
        isEditingWorkspaces: false,
      };

    case InboxesPanelActionsEnum.TOGGLE_SEARCH_QUERY_BUILDER_DROPDOWN:
      return {
        ...state,
        isSearchQueryBuilderDropdownOpen: !state.isSearchQueryBuilderDropdownOpen,
      };

    default:
      return state;
  }
}
